import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-wizard-step-multi-menu',
  templateUrl: './wizard-step-multi-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-step-multi-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-220%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),

    trigger('slideInOutMobile', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('reglageSlideOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutRigth', [
      state('in', style({
        transform: 'translate3d(200%,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOutForme', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutWindowsAnswers', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ])
  ]

})
export class WizardStepMultiMenuComponent extends WizardHpBaseComponent implements OnInit {
  @Input() answer_index;
  @Input() question_code;
  @Input()  menuAnswersStepMenuState: string ="in";
  @Input() answers :any;
  @Input() menu_selected  = 0;
  @Input() answerProgress = false;
  @Input() currentMenuProductStep = "OUVERTURE";
  @Input() globalDataLength:any;
  answers_variable = [];
  answers_variableId = [];
  filterDisplay = false;
  infoBulle = true;
  menuAnswerStep:any;
 currentIndex = 0;
  currentKeyword:any;
  currenTitle= "";
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
    this.menuAnswerStep = this.getHpService().getListCataglog();
    
   
          
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.currentIndex = 0;
    this.currentKeyword = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[0].keyword;
    this.currenTitle = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[0].title;
    
   
  }
  pushVariable(index_, id) {
    this.answers_variableId[index_] = id;
  }

  getVariable(isValeur) {
    return (isValeur === "valeur") ? this.answers_variable.join() : this.answers_variableId.join()
  }
  getClassName(keywords) {
    if (keywords) {
      return keywords.replace(/,/gi, ' ').toLowerCase();
    }
  }
  showFilter() {
    this.filterDisplay = (this.filterDisplay) ? false : true;
  }
  getViewValue(hasInOrOutView){
    console.log("answer 114 " +this.getHpService().getView())
    if(hasInOrOutView)
    {
      return;
    }
    this.getSimulateur().getViewValue(this.getHpService().getView());
    
  }

  getViewOutsideAnswerId()
  {
   return this.getHpService().getViewInsideAnswerId();    
  }

  displayInfo()
  {
  this.infoBulle = this.infoBulle ? false: true;
  }
  
  hiddenInfo()
  {
  if( this.infoBulle)
  {
  this.infoBulle = false;
  }  
  }
  onScroll(e:any)
  {
  console.log(e)
  this.infoBulle = false;
  }
  fetchAnswersProducts(step)
  {
    let currentProduct_index =  this.getHpService().getMultiGlobaldata().length -1 ;
    this.getHpService().setCurrentProductIndex(currentProduct_index);
    this.currentIndex = (step === "next_") ? this.currentIndex + 1 : this.currentIndex -1;
    var  keyword_ = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[this.currentIndex].keyword;
    this.currentKeyword = keyword_;
    this.currenTitle = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[this.currentIndex].title;   
    this.getHpService().setCurrentKeyword(keyword_);
    this.getSimulateur().fetchAnswersProducts(this.getHpService().getQuestionObject(keyword_).grpId, this.getHpService().getQuestionObject(keyword_).id, this.getHpService().getRootProductElt(), 
    this.getHpService().getQuestionObject(keyword_).code,this.getHpService().getQuestionObject(keyword_).keywords,2,1)
  }
 putAnswerSelected(question_id, id, elt)
  {
    let currentProductIndex  =  this.getHpService().getMultiGlobaldata().length -1;
    this.getHpService().setCurrentProductIndex(currentProductIndex);
    this.getSimulateur().putAnswerSelected(question_id,id, elt);
     
  }
  init()
  {
    this.currentIndex =0;
    this.currentKeyword = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[this.currentIndex].keyword;
    this.currenTitle = this.getHpService().getListCataglog()[this.menu_selected].menuProduct_step[this.currentIndex].title;   
  }
}
